import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function BA_mobile_view_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
    <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography className='fs-6'>1. Introduction to Python</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        Basics of python, Data types & list & dictionary & array, string operations, Conditions & loops, Statistics Fundamentals & theorems, Fundamentals of programming, Anaconda & jupyter notebook, Functions & modules class hands.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2bh-content"
        id="panel2bh-header"
      >
        <Typography className='fs-6'>2. Introduction to Data Analysis</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        Data analysis using Numpy, Data analysis using Pandas, Data visualization using Matplotlib, Data visualization using Seaborn 3.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel3bh-content"
        id="panel3bh-header"
      >
        <Typography className='fs-6'>3. Introduction to Statistics</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        Fundamentals of statistics & probability, Statistical Thinking and types, Descriptive & Inferential statistics, Hypothesis testing & linear alberas, Data processing & exploratory data analysis.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel4bh-content"
        id="panel4bh-header"
      >
        <Typography className='fs-6'>4. Introduction to Data science & tools</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        SQL & advance SQL & RDBMS, NOSQL, HBase & MongoDB, Programming with SQL, JSON Data & CRUD.            
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel5bh-content"
        id="panel5bh-header"
      >
        <Typography className='fs-6'>5. Introduction to BI</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        Intro to Business Intelligence, BI Tools and its programming, Big data & Spark analytics: Intro to Hadoop, Intro to Big data, Spark analytics, PySpark hands, Spark RDD Programming.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel6bh-content"
        id="panel6bh-header"
      >
        <Typography className='fs-6'>6. Time Series</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        Intro to time series & its forecasting, ARIMA Model, Time series analysis with Pandas & FB Prophet
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel7bh-content"
        id="panel7bh-header"
      >
        <Typography className='fs-6'>7. Essential Tools</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        Intro to Business analytics & stakeholders, Formulating & analyzing & transforming requirement, Flowchart & modeling, Finalizing Requirement.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel8bh-content"
        id="panel8bh-header"
      >
        <Typography className='fs-6'>8. EXCEL & WEBPAGE</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        Excel & different tools (Hiding, display in, moving, switching, inserting, deleting cells, rows, columns & forms, charts, pie chart) Data analysis & pivot tables, Webapp using streamlit.
        </Typography>
      </AccordionDetails>
    </Accordion>
    <Accordion className='py-2' expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel9bh-content"
        id="panel9bh-header"
      >
        <Typography className='fs-6'>9. MINOR & MAJOR PROJECT</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>
        Minor Project, Major Project, Project Overview.
        </Typography>
      </AccordionDetails>
    </Accordion>
  </div>
  );
}
